module.exports = __webpack_public_path__ + "static/media/2023-logo.1e7509a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Menu/img/2023-logo.png
// module id = 56
// module chunks = 0